import { useState } from "react";
import type { DateRange } from "react-day-picker";

function fmtIso(d: Date | undefined): string | undefined {
  if (!d) return undefined;
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

// Standard default — last 3 months. Matches the Commusoft backup window.
export function defaultRange(): DateRange {
  const today = new Date();
  const start = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
  return { from: start, to: today };
}

// Single hook every report page consumes. Returns the state + the
// `?from=YYYY-MM-DD&to=YYYY-MM-DD` query string to splice into fetch URLs
// and a key suffix to slot into React Query's queryKey array so refetch
// fires when the range changes.
export function useDateRange(initial?: DateRange) {
  const [dateRange, setDateRange] = useState<DateRange | undefined>(initial ?? defaultRange());
  const from = fmtIso(dateRange?.from);
  const to = fmtIso(dateRange?.to);
  const rangeQs = from && to ? `?from=${from}&to=${to}` : "";
  return { dateRange, setDateRange, from, to, rangeQs };
}
